query InvoiceBatches($id: UUID!, $orderBy: [InvoiceBatchesOrderBy!]) {
  invoiceBatches(
    orderBy: $orderBy
    filter: { batchTransactionId: { equalTo: $id } }
  ) {
    nodes {
      id
      isVerified
      _isVerifiable
      comment
      _rowTimestamp
      batchTransactionId
      invoiceId
      invoiceBatchTransactionType {
        transactionType
      }
      invoice {
        _documentPackageId
        vendorReference
        invoiceNumber
        description
        invoiceDate
        _accountingStampTransactionReference
        _isAccountingEntryStampedComplete
      }

      appliedAmount
      _isDeletable
    }
    aggregates {
      sum {
        appliedAmount
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
